"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: acquiring/card-acquiring-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Facquiring%2Fcard-acquiring-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardAcquiringServiceClient = exports.GetProviderKeyResponse = exports.GetProviderKeyRequest = exports.AddCardResponse = exports.AddCardRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const external_account_1 = require("../common/external-account");
const external_card_1 = require("../common/external-card");
const protobufPackage = 'com.step.acquiring.proto';
function createBaseAddCardRequest() {
    return {
        token: external_card_1.CardToken.fromPartial({}),
        name: '',
        entryMethod: external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD,
    };
}
exports.AddCardRequest = {
    fromJSON(object) {
        const message = {
            token: isSet(object.token) ? external_card_1.CardToken.fromJSON(object.token) : external_card_1.CardToken.fromPartial({}),
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        if (isSet(object.entryMethod)) {
            message.entryMethod = (0, external_card_1.externalCardEntryMethodFromJSON)(object.entryMethod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== undefined) {
            obj.token = external_card_1.CardToken.toJSON(message.token);
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.entryMethod !== undefined &&
            message.entryMethod !== external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD) {
            obj.entryMethod = (0, external_card_1.externalCardEntryMethodToJSON)(message.entryMethod);
        }
        return obj;
    },
    create(base) {
        return exports.AddCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddCardRequest();
        message.token = (object.token !== undefined && object.token !== null)
            ? external_card_1.CardToken.fromPartial(object.token)
            : external_card_1.CardToken.fromPartial({});
        message.name = object.name ?? '';
        message.entryMethod = object.entryMethod ??
            external_card_1.ExternalCardEntryMethod.INVALID_EXTERNAL_CARD_ENTRY_METHOD;
        return message;
    },
};
function createBaseAddCardResponse() {
    return { account: external_account_1.ExternalAccount.fromPartial({}) };
}
exports.AddCardResponse = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account)
                ? external_account_1.ExternalAccount.fromJSON(object.account)
                : external_account_1.ExternalAccount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = external_account_1.ExternalAccount.toJSON(message.account);
        }
        return obj;
    },
    create(base) {
        return exports.AddCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddCardResponse();
        message.account = (object.account !== undefined && object.account !== null)
            ? external_account_1.ExternalAccount.fromPartial(object.account)
            : external_account_1.ExternalAccount.fromPartial({});
        return message;
    },
};
function createBaseGetProviderKeyRequest() {
    return { provider: external_card_1.ExternalCardProvider.INVALID_PROVIDER };
}
exports.GetProviderKeyRequest = {
    fromJSON(object) {
        const message = {
            provider: isSet(object.provider)
                ? (0, external_card_1.externalCardProviderFromJSON)(object.provider)
                : external_card_1.ExternalCardProvider.INVALID_PROVIDER,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.provider !== external_card_1.ExternalCardProvider.INVALID_PROVIDER) {
            obj.provider = (0, external_card_1.externalCardProviderToJSON)(message.provider);
        }
        return obj;
    },
    create(base) {
        return exports.GetProviderKeyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProviderKeyRequest();
        message.provider = object.provider ?? external_card_1.ExternalCardProvider.INVALID_PROVIDER;
        return message;
    },
};
function createBaseGetProviderKeyResponse() {
    return { id: '', key: '' };
}
exports.GetProviderKeyResponse = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            key: isSet(object.key) ? globalThis.String(object.key) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.key !== '') {
            obj.key = message.key;
        }
        return obj;
    },
    create(base) {
        return exports.GetProviderKeyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProviderKeyResponse();
        message.id = object.id ?? '';
        message.key = object.key ?? '';
        return message;
    },
};
/**
 * Card Acquiring Service API.
 *
 * Manages a user's external card sources.
 */
class CardAcquiringServiceClient {
    rpc;
    name = 'com.step.acquiring.proto.CardAcquiringService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/acquiring';
    methods = [{
            name: 'AddCard',
            requestType: exports.AddCardRequest,
            responseType: exports.AddCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetProviderKey',
            requestType: exports.GetProviderKeyRequest,
            responseType: exports.GetProviderKeyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Adds an external card.
     */
    addCard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets the provider-specific key used to tokenize card data.
     */
    getProviderKey(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CardAcquiringServiceClient = CardAcquiringServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card-acquiring-service.js.map